import notDeleted from '../../notDeleted'

// De antwoordkolommen van één matrixvraag ('Helemaal mee oneens' … 'Helemaal
// mee eens'). Nodig voor de verdeling per stelling (matrixDistribution.js):
// zonder kolommen is er geen schaalvolgorde en ontbreken de antwoorden die
// niemand gaf.
//
// Zelfde vorm als getMatrixRowDefs: op `Field`, niet op CompagnyID, omdat een
// portfoliokaart een vraag van een andere organisatie kan tonen. Stellingen en
// kolommen van één vraag moeten uit dezelfde bron komen.

/**
 * @param {string} fieldId - QuestionnaireFields.ID
 * @param {object} db - Firestore
 * @param {Map<string, Array<object>>} columnsCache - Sessie-cache per vraag
 * @returns {Promise<Array<object>>} MatrixQuestionColumns, zonder zacht verwijderde
 */
const getMatrixColumns = async (fieldId, db, columnsCache) => {
  if (columnsCache.has(fieldId)) return columnsCache.get(fieldId)
  const snap = await db.collection('MatrixQuestionColumns').where('Field', '==', fieldId).get()
  const columns = snap.docs.map(d => d.data()).filter(notDeleted)
  columnsCache.set(fieldId, columns)
  return columns
}

export default getMatrixColumns
